import { apiClient } from './base';

export const getOrderOrigins = async () => {
  const response = await apiClient.get('/order-origins');
  return response.data.orderOrigins || [];
};
